var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('authorization-wrapper',[_c('reset-password',{attrs:{"error":_vm.error},on:{"submit":_vm.submit,"clearError":function($event){return _vm.clearError()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }